// Phase 2 i18n additions (merged into main dict by translations.js)
export const phase2 = {
  en: {
    // Navbar
    nav_pricing: "Pricing",
    nav_billing: "Billing",
    plan_FREE: "FREE",
    plan_TRADER: "TRADER",
    plan_PRO: "PRO",
    plan_OWNER: "OWNER",
    // Quota
    quota_remaining: "analyses remaining this month",
    quota_used: "/ 100 analyses used",
    quota_unlimited: "Unlimited analyses",
    quota_owner: "Owner — Unlimited",
    quota_resets_on: "Resets on",
    // Pricing page
    pricing_title: "Simple, transparent pricing",
    pricing_subtitle: "Start free. Upgrade when you're ready.",
    pricing_monthly: "Monthly",
    pricing_most_popular: "MOST POPULAR",
    pricing_free_cta: "Start Free",
    pricing_trader_cta: "Get Trader",
    pricing_pro_cta: "Go Pro",
    pricing_current_cta: "Current Plan",
    pricing_analyses_5: "5 analyses / month",
    pricing_analyses_100: "100 analyses / month",
    pricing_analyses_unlimited: "Unlimited analyses",
    pricing_feat_langs: "FR / EN interface",
    pricing_feat_styles: "All trading styles",
    pricing_feat_export: "Export PDF",
    pricing_feat_history: "Full history",
    pricing_feat_priority: "Priority AI",
    pricing_feat_api: "API access (soon)",
    pricing_per_month: "/mo",
    pricing_free_label: "Free forever",
    pricing_faq_title: "Pricing FAQ",
    pricing_faq_q1: "Can I cancel anytime?",
    pricing_faq_a1: "Yes. Cancel from your billing dashboard anytime. No commitment.",
    pricing_faq_q2: "What happens when I reach my limit?",
    pricing_faq_a2: "You'll be prompted to upgrade. Your existing analyses are never deleted.",
    pricing_faq_q3: "Do you offer refunds?",
    pricing_faq_a3: "We offer a 7-day refund policy on first purchase. Contact us at support@candle.ai",
    pricing_faq_q4: "Is my payment secure?",
    pricing_faq_a4: "Yes. Payments are processed by Stripe, a PCI-DSS Level 1 certified provider.",
    pricing_faq_q5: "What currencies are accepted?",
    pricing_faq_a5: "USD only at the moment. EUR support coming soon.",
    pricing_faq_q6: "Can I upgrade or downgrade?",
    pricing_faq_a6: "Yes, anytime from your billing dashboard. Changes apply immediately.",
    // Billing page
    billing_title: "Billing & Subscription",
    billing_current_plan: "CURRENT PLAN",
    billing_analyses_used: "Analyses used this month",
    billing_upgrade: "Upgrade Plan →",
    billing_subscription: "SUBSCRIPTION",
    billing_status: "Status",
    billing_manage: "Manage Subscription →",
    billing_owner_title: "OWNER ACCOUNT",
    billing_owner_desc: "∞ Unlimited analyses · No billing — Owner access",
    billing_no_sub: "You don't have an active subscription. Upgrade to unlock more analyses.",
    // Upgrade modal
    upgrade_title: "You've used all your analyses",
    upgrade_subtitle: "Upgrade to keep analyzing charts and never miss a trade setup.",
    upgrade_maybe_later: "Maybe later",
    // Success / cancel banners
    success_subscribed: "Welcome to {plan}! Your plan is now active.",
    cancel_back: "No worries — you're still on the Free plan.",
    // Forgot / reset password
    forgot_link: "Forgot your password?",
    forgot_title: "Reset your password",
    forgot_desc: "Enter your email and we'll send you a reset link.",
    forgot_submit: "Send reset link",
    forgot_sent: "If that email exists, a reset link has been sent.",
    reset_title: "Set a new password",
    reset_submit: "Update password",
    reset_success: "Password updated. You can now log in.",
    reset_invalid: "Invalid or expired token.",
    // Export / clipboard
    export_pdf: "Export PDF",
    copy_levels: "Copy Levels",
    copy_done: "Copied!",
    export_upgrade_tooltip: "Upgrade to Trader to export PDFs",
    // Coupon
    coupon_label: "Have a promo code?",
    coupon_placeholder: "Enter promo code",
    coupon_apply: "Apply",
    coupon_remove: "Remove",
    coupon_applied: "applied",
    coupon_invalid: "Invalid promo code",
    // Watchlist
    nav_watchlist: "Watchlist",
    watchlist_title: "Watchlist",
    watchlist_add: "Add Symbol",
    watchlist_empty: "Your watchlist is empty. Add symbols to track.",
    watchlist_analyze: "Analyze →",
    watchlist_add_alert: "Add alert",
    watchlist_alert_above: "Above",
    watchlist_alert_below: "Below",
    watchlist_alert_set: "Set Alert",
    watchlist_alert_modal_title: "Set price alert",
    watchlist_alert_me: "Alert me when price is",
    watchlist_analyses_count: "analyses",
    watchlist_limit: "Upgrade to Trader to add more than 20 symbols",
    // EarlyBird banner
    banner_text: "Early Bird offer — Use code",
    banner_code: "EARLYBIRD30",
    banner_suffix: "for 30% off your first 3 months.",
    banner_cta: "Get Started →",
    // Login polish
    login_subtitle: "Sign in to your CANDLE.AI account",
    login_email_invalid: "Please enter a valid email",
    login_error_generic: "Invalid email or password",
    login_loading: "Signing in...",
    login_no_account: "Don't have an account?",
    signup_loading: "Creating account...",
    signup_have_account: "Already have an account?",
    // Community (Phase 4b)
    nav_community: "Community",
    community_title: "Community Feed",
    community_subtitle: "Public analyses shared by CANDLE.AI traders.",
    community_empty: "No shared analyses yet. Be the first to share!",
    community_filter_all: "All",
    community_filter_direction: "Direction",
    community_filter_market: "Market",
    community_load_more: "Load more",
    community_likes: "likes",
    community_like: "Like",
    community_unlike: "Unlike",
    community_login_to_like: "Sign in to like",
    community_by: "by",
    community_shared: "shared",
    community_view_full: "View full analysis →",
    community_back: "← Back to feed",
    community_share_twitter: "Share on Twitter",
    community_share_discord: "Copy Discord link",
    community_link_copied: "Link copied to clipboard",
    share_btn: "Share",
    share_to_community: "Share to Community",
    share_remove: "Remove from Community",
    share_public_label: "Public on Community",
    share_success: "Analysis shared to Community!",
    share_unshare_success: "Removed from Community.",
    share_requires_upgrade: "Upgrade to Trader or Pro to share to the Community.",
    share_dialog_title: "Share to Community",
    share_dialog_desc: "Your analysis will appear publicly with your first name only. Levels, direction, and patterns will be visible. You can remove it anytime.",
    share_confirm: "Share publicly",
    share_cancel: "Cancel",
    market_CRYPTO: "Crypto",
    market_FOREX: "Forex",
    market_EQUITY: "Equity",
    // Phase 4c — Leaderboard / Trending / Comments / Follow
    leaderboard_title: "Top Traders",
    leaderboard_subtitle: "Most-liked traders this period.",
    leaderboard_period_7d: "7 days",
    leaderboard_period_30d: "30 days",
    leaderboard_empty: "No public activity in this period yet.",
    leaderboard_shared_count: "shared",
    sort_recent: "Recent",
    sort_trending: "Trending",
    sort_top: "Top liked",
    trending_badge: "Trending",
    follow_btn: "Follow",
    follow_following: "Following",
    follow_followers: "followers",
    follow_login_required: "Sign in to follow",
    follow_success: "Now following",
    unfollow_success: "Unfollowed",
    comments_label: "Comments",
    comments_empty: "Be the first to comment.",
    comments_placeholder: "Share your view…",
    comments_post: "Post",
    comments_login_required: "Sign in to comment",
    comments_delete: "Delete",
    comments_count_label: "comments",
  },
  fr: {
    nav_pricing: "Tarifs",
    nav_billing: "Facturation",
    plan_FREE: "GRATUIT",
    plan_TRADER: "TRADER",
    plan_PRO: "PRO",
    plan_OWNER: "OWNER",
    quota_remaining: "analyses restantes ce mois",
    quota_used: "/ 100 analyses utilisées",
    quota_unlimited: "Analyses illimitées",
    quota_owner: "Owner — Illimité",
    quota_resets_on: "Réinitialisation le",
    pricing_title: "Tarification simple et transparente",
    pricing_subtitle: "Commencez gratuitement. Passez au niveau supérieur quand vous êtes prêt.",
    pricing_monthly: "Mensuel",
    pricing_most_popular: "PLUS POPULAIRE",
    pricing_free_cta: "Commencer",
    pricing_trader_cta: "Choisir Trader",
    pricing_pro_cta: "Passer Pro",
    pricing_current_cta: "Plan actuel",
    pricing_analyses_5: "5 analyses / mois",
    pricing_analyses_100: "100 analyses / mois",
    pricing_analyses_unlimited: "Analyses illimitées",
    pricing_feat_langs: "Interface FR / EN",
    pricing_feat_styles: "Tous les styles de trading",
    pricing_feat_export: "Export PDF",
    pricing_feat_history: "Historique complet",
    pricing_feat_priority: "IA prioritaire",
    pricing_feat_api: "Accès API (bientôt)",
    pricing_per_month: "/mois",
    pricing_free_label: "Gratuit pour toujours",
    pricing_faq_title: "FAQ Tarification",
    pricing_faq_q1: "Puis-je annuler à tout moment ?",
    pricing_faq_a1: "Oui. Annulez depuis votre tableau de bord facturation à tout moment. Sans engagement.",
    pricing_faq_q2: "Que se passe-t-il quand j'atteins ma limite ?",
    pricing_faq_a2: "Une fenêtre vous proposera d'upgrader. Vos analyses existantes ne sont jamais supprimées.",
    pricing_faq_q3: "Proposez-vous des remboursements ?",
    pricing_faq_a3: "Politique de remboursement de 7 jours sur le premier achat. Contactez support@candle.ai",
    pricing_faq_q4: "Mon paiement est-il sécurisé ?",
    pricing_faq_a4: "Oui. Les paiements sont traités par Stripe, certifié PCI-DSS Niveau 1.",
    pricing_faq_q5: "Quelles devises sont acceptées ?",
    pricing_faq_a5: "USD uniquement pour l'instant. Le support EUR arrive bientôt.",
    pricing_faq_q6: "Puis-je changer de plan ?",
    pricing_faq_a6: "Oui, à tout moment depuis votre tableau de bord. Les changements s'appliquent immédiatement.",
    billing_title: "Facturation & Abonnement",
    billing_current_plan: "PLAN ACTUEL",
    billing_analyses_used: "Analyses utilisées ce mois",
    billing_upgrade: "Changer de plan →",
    billing_subscription: "ABONNEMENT",
    billing_status: "Statut",
    billing_manage: "Gérer l'abonnement →",
    billing_owner_title: "COMPTE OWNER",
    billing_owner_desc: "∞ Analyses illimitées · Pas de facturation — Accès Owner",
    billing_no_sub: "Aucun abonnement actif. Upgradez pour débloquer plus d'analyses.",
    upgrade_title: "Vous avez utilisé toutes vos analyses",
    upgrade_subtitle: "Upgradez pour continuer à analyser vos graphiques et ne jamais manquer un setup.",
    upgrade_maybe_later: "Plus tard",
    success_subscribed: "Bienvenue sur {plan} ! Votre plan est actif.",
    cancel_back: "Pas de souci — vous êtes toujours sur le plan Gratuit.",
    forgot_link: "Mot de passe oublié ?",
    forgot_title: "Réinitialiser votre mot de passe",
    forgot_desc: "Entrez votre email pour recevoir un lien de réinitialisation.",
    forgot_submit: "Envoyer le lien",
    forgot_sent: "Si cet email existe, un lien a été envoyé.",
    reset_title: "Définir un nouveau mot de passe",
    reset_submit: "Mettre à jour",
    reset_success: "Mot de passe mis à jour. Vous pouvez vous connecter.",
    reset_invalid: "Token invalide ou expiré.",
    export_pdf: "Export PDF",
    copy_levels: "Copier les niveaux",
    copy_done: "Copié !",
    export_upgrade_tooltip: "Passez à Trader pour exporter en PDF",
    coupon_label: "Vous avez un code promo ?",
    coupon_placeholder: "Entrez votre code promo",
    coupon_apply: "Appliquer",
    coupon_remove: "Retirer",
    coupon_applied: "appliqué",
    coupon_invalid: "Code promo invalide",
    nav_watchlist: "Watchlist",
    watchlist_title: "Watchlist",
    watchlist_add: "Ajouter un symbole",
    watchlist_empty: "Votre watchlist est vide. Ajoutez des symboles à suivre.",
    watchlist_analyze: "Analyser →",
    watchlist_add_alert: "Ajouter une alerte",
    watchlist_alert_above: "Au-dessus de",
    watchlist_alert_below: "En-dessous de",
    watchlist_alert_set: "Définir l'alerte",
    watchlist_alert_modal_title: "Définir une alerte de prix",
    watchlist_alert_me: "M'alerter quand le prix est",
    watchlist_analyses_count: "analyses",
    watchlist_limit: "Passez au plan Trader pour ajouter plus de 20 symboles",
    banner_text: "Offre Early Bird — Utilisez le code",
    banner_code: "EARLYBIRD30",
    banner_suffix: "pour 30% de réduction pendant 3 mois.",
    banner_cta: "Commencer →",
    login_subtitle: "Connectez-vous à votre compte CANDLE.AI",
    login_email_invalid: "Veuillez entrer un email valide",
    login_error_generic: "Email ou mot de passe invalide",
    login_loading: "Connexion...",
    login_no_account: "Pas encore de compte ?",
    signup_loading: "Création...",
    signup_have_account: "Déjà un compte ?",
    // Community (Phase 4b)
    nav_community: "Communauté",
    community_title: "Fil Communauté",
    community_subtitle: "Analyses publiques partagées par les traders CANDLE.AI.",
    community_empty: "Aucune analyse partagée pour le moment. Soyez le premier !",
    community_filter_all: "Tous",
    community_filter_direction: "Direction",
    community_filter_market: "Marché",
    community_load_more: "Voir plus",
    community_likes: "j'aime",
    community_like: "J'aime",
    community_unlike: "Retirer",
    community_login_to_like: "Connectez-vous pour aimer",
    community_by: "par",
    community_shared: "partagé",
    community_view_full: "Voir l'analyse complète →",
    community_back: "← Retour au fil",
    community_share_twitter: "Partager sur Twitter",
    community_share_discord: "Copier le lien Discord",
    community_link_copied: "Lien copié dans le presse-papiers",
    share_btn: "Partager",
    share_to_community: "Partager à la Communauté",
    share_remove: "Retirer de la Communauté",
    share_public_label: "Public sur la Communauté",
    share_success: "Analyse partagée à la Communauté !",
    share_unshare_success: "Retiré de la Communauté.",
    share_requires_upgrade: "Passez à Trader ou Pro pour partager à la Communauté.",
    share_dialog_title: "Partager à la Communauté",
    share_dialog_desc: "Votre analyse apparaîtra publiquement avec uniquement votre prénom. Les niveaux, direction et patterns seront visibles. Vous pouvez la retirer à tout moment.",
    share_confirm: "Partager publiquement",
    share_cancel: "Annuler",
    market_CRYPTO: "Crypto",
    market_FOREX: "Forex",
    market_EQUITY: "Actions",
    // Phase 4c — Leaderboard / Trending / Comments / Follow
    leaderboard_title: "Top Traders",
    leaderboard_subtitle: "Les traders les plus likés sur la période.",
    leaderboard_period_7d: "7 jours",
    leaderboard_period_30d: "30 jours",
    leaderboard_empty: "Aucune activité publique sur cette période.",
    leaderboard_shared_count: "partagées",
    sort_recent: "Récent",
    sort_trending: "Tendance",
    sort_top: "Top likes",
    trending_badge: "Tendance",
    follow_btn: "Suivre",
    follow_following: "Suivi",
    follow_followers: "abonnés",
    follow_login_required: "Connectez-vous pour suivre",
    follow_success: "Vous suivez maintenant",
    unfollow_success: "Désabonné",
    comments_label: "Commentaires",
    comments_empty: "Soyez le premier à commenter.",
    comments_placeholder: "Partagez votre avis…",
    comments_post: "Publier",
    comments_login_required: "Connectez-vous pour commenter",
    comments_delete: "Supprimer",
    comments_count_label: "commentaires",
  },
};
